/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '../Button';
import Input from '../Input';

const EditSystemModalBody = ({ systemInfo, setQuantity, quantityError, intl }) => (
  <div>
    <div className="dis-flex f-dir-column mr-top-24">
      <label htmlFor="reportType">
        <FormattedMessage
          id="Report Category"
          defaultMessage="Report Category"
        />
      </label>
      <input
        type="text"
        value={systemInfo.reportType ? intl.formatMessage({ id: systemInfo.reportType, defaultMessage: systemInfo.reportType }) : ''}
        className="form-control"
        disabled
        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
      />
    </div>

    <div className="dis-flex f-dir-column mr-top-24">
      <label htmlFor="systemDeviceType">
        <FormattedMessage id="System/Device" defaultMessage="System/Device" />
      </label>
      <input
        type="text"
        value={systemInfo.systemDeviceType ? intl.formatMessage({ id: systemInfo.systemDeviceType, defaultMessage: systemInfo.systemDeviceType }) : ''}
        className="form-control"
        disabled
        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
      />
    </div>

    <div className="dis-flex f-dir-column mr-top-24">
      <label htmlFor="type">
        <FormattedMessage id="Type" defaultMessage="Type" />
      </label>
      <input
        type="text"
        value={systemInfo.type ? intl.formatMessage({ id: systemInfo.type, defaultMessage: systemInfo.type }) : ''}
        className="form-control"
        disabled
        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
      />
    </div>

    <div className="dis-flex f-dir-column mr-top-24">
      {quantityError && (
        <span className="errorMessage">
          <FormattedMessage defaultMessage={quantityError} id={quantityError} />
        </span>
      )}
      <Input
        type="text"
        subType="int"
        value={systemInfo.quantity || ''}
        name="quantity"
        className="form-control"
        onChange={(e) => setQuantity(e.target.value)}
      />
      <label htmlFor="quantity">
        <FormattedMessage id="Quantity*" defaultMessage="Quantity*" />
      </label>
    </div>
  </div>
);

const EditSystemModalFooter = ({ handleClickSave }) => (
  <div className="cust-select-btns mr-top-24">
    <Button text="Save" color="#6AA14E" onBtnClick={handleClickSave} />
  </div>
);

EditSystemModalBody.propTypes = {
  systemInfo: PropTypes.object.isRequired,
  setQuantity: PropTypes.func.isRequired,
  quantityError: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

EditSystemModalFooter.propTypes = {
  handleClickSave: PropTypes.func.isRequired,
};

const WrappedEditSystemModalBody = injectIntl(EditSystemModalBody);

export { WrappedEditSystemModalBody as EditSystemModalBody, EditSystemModalFooter };
